/**
 * @author Furkan khan
 * @created 2026-03-27
 * @description public view routing
 */

import { Routes } from '@angular/router';
import { PublicViewComponent } from 'src/app/views/public-view/public-view.component';

export const PublicViewRoutes: Routes = [
  {
    path: 'jurisdiction/:clientId',
    children: [
      {
        path: 'public-view',
        component: PublicViewComponent
      }
    ]
  }
];